/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = require('dispatchr/addons/createStore');



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/addons/createStore.js
// module id = 293
// module chunks = 0